module.exports = __webpack_public_path__ + "static/media/logo.019d59da.png";